"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHistory = void 0;
const bridge_1 = require("../bridge");
const callBridge = (0, bridge_1.getCallBridge)();
const createHistory = async () => {
    const history = await callBridge('createHistory');
    history.listen((location) => {
        history.location = location;
    });
    return history;
};
exports.createHistory = createHistory;
